module.exports = __webpack_public_path__ + "static/Sonae-dd7c036614d769f35d8fe84690d80a79.webp";